import React from 'react';
import { TemplateRenderer } from '@/src/modules/templates';
import type { InvitationData } from '@/src/modules/templates/types';

const DAY_MS = 24 * 60 * 60 * 1000;
const DEMO_WEDDING_DATE = new Date(Date.now() + 60 * DAY_MS);
// Demo-only function dates, relative to the demo wedding date (YYYY-MM-DD).
const demoDate = (offsetDays: number) =>
  new Date(DEMO_WEDDING_DATE.getTime() + offsetDays * DAY_MS).toISOString().slice(0, 10);

const DEMO_DATA: InvitationData = {
  id: 'demo-plot-plane',
  invitationId: null,
  templateId: 'royal-mandap-palace',
  occasionType: 'WEDDING',
  status: 'DRAFT',
  eventName: 'Vikram & Ananya',
  eventDate: DEMO_WEDDING_DATE.toISOString(),
  eventVenue: 'City Palace Courtyard, Udaipur',
  hostName: 'Sharma & Rao Families',
  customMessage: 'Your presence would honour our families as we celebrate with music, colour, and grace.',
  rsvpLink: '#',
  mediaUrls: [],
  customData: {
    wedding: {
      groom: { fullName: 'Vikram Sharma', nickname: 'Vikram' },
      bride: { fullName: 'Ananya Rao', nickname: 'Ananya' },
      weddingEvents: [
        { title: 'Mehndi', date: demoDate(-2), startTime: '4:00 PM', venue: 'Haveli terrace' },
        { title: 'Haldi', date: demoDate(-1), startTime: '10:00 AM', venue: 'Courtyard lawn' },
        { title: 'Sangeet', date: demoDate(-1), startTime: '8:00 PM', venue: 'Royal ballroom' },
        { title: 'Reception', date: demoDate(0), startTime: '7:30 PM', venue: 'Palace lawns' },
      ],
    },
  },
};

export default function PlotPlaneTemplateDemo({ templateId }: { templateId: string }) {
  const data: InvitationData = { ...DEMO_DATA, templateId };
  return (
    <div className="min-h-screen">
      <TemplateRenderer templateId={templateId} data={data} />
    </div>
  );
}
